const colors = {
  gray: '#ececec',
  thoughtsBackgroundColor: 'white',
  accent: '#333959'
};

export default colors;


// WEBPACK FOOTER //
// ./src/config/colors.js